/**
 * Where the "Access my special rates and pay using Travel Card balance" box
 * starts for a customer who holds travel cards: their own choice from earlier
 * in this session if they made one, otherwise ticked whenever there is a
 * balance to pay with. Never ticked at £0.00 - there is nothing to pay with,
 * and ticking it then is refused in favour of a top-up prompt.
 */
const getInitialUseTravelCard = balance => {
  if (!(Number(balance) > 0)) return false
  try {
    const persisted = sessionStorage.getItem('rfUseTravelCard')
    if (persisted != null) return JSON.parse(persisted) === true
  } catch (err) {
    // unreadable storage - fall through to the default
  }
  return true
}

export default getInitialUseTravelCard
